import type { SupportedCurrency } from '@/lib/currency';

export const UPI_AUTOPAY_MAX_RECURRING_AMOUNT_INR = 15000;

type RazorpayInstrument = {
  method: 'upi' | 'card' | 'emandate' | 'netbanking' | 'wallet';
};

type RazorpayCheckoutDisplayConfig = {
  display: {
    blocks: Record<
      string,
      {
        name: string;
        instruments: RazorpayInstrument[];
      }
    >;
    sequence: string[];
    preferences: {
      show_default_blocks: boolean;
    };
  };
};

export function buildUpiAutopayFirstSubscriptionConfig(opts: {
  currency?: SupportedCurrency | string | null;
  recurringAmount?: number | null;
} = {}): RazorpayCheckoutDisplayConfig | undefined {
  const currency = opts.currency || 'INR';
  const amount = opts.recurringAmount;

  if (currency !== 'INR') return undefined;
  if (typeof amount === 'number' && amount >= UPI_AUTOPAY_MAX_RECURRING_AMOUNT_INR) {
    return undefined;
  }

  return {
    display: {
      blocks: {
        upi_autopay: {
          name: 'UPI AutoPay',
          instruments: [{ method: 'upi' }],
        },
        other_recurring: {
          name: 'Cards and bank mandate',
          instruments: [{ method: 'card' }, { method: 'emandate' }],
        },
      },
      sequence: ['block.upi_autopay', 'block.other_recurring'],
      preferences: {
        show_default_blocks: false,
      },
    },
  };
}

export function buildUpiFirstOneTimePaymentConfig(opts: {
  currency?: SupportedCurrency | string | null;
} = {}): RazorpayCheckoutDisplayConfig | undefined {
  if ((opts.currency || 'INR') !== 'INR') return undefined;

  return {
    display: {
      blocks: {
        upi: {
          name: 'UPI',
          instruments: [{ method: 'upi' }],
        },
        other_methods: {
          name: 'Cards, netbanking and wallets',
          instruments: [{ method: 'card' }, { method: 'netbanking' }, { method: 'wallet' }],
        },
      },
      sequence: ['block.upi', 'block.other_methods'],
      preferences: {
        show_default_blocks: false,
      },
    },
  };
}
